export default {"src":"/_next/static/media/digitalproduct-2.0aeec2d9.svg","height":97,"width":242,"blurWidth":0,"blurHeight":0};